import {
  ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION,
  ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION,
  ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION,
  ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION,
  ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO,
  ACT_INSTANCES_SET_SELECTED_BUILDING,
  ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION,
} from '../../constants/actions';

export const fetchBuildingsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION,
});

export const fetchBuildingsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION,
  payload: data,
});

export const filterBuildingsInitAction = () => ({
  type: ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION,
});

export const filterBuildingsSuccessAction = data => ({
  type: ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION,
  payload: data,
});

export const updateBuildingsFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION,
  payload: filters,
});

export const setSelectedBuildingAction = building => ({
  type: ACT_INSTANCES_SET_SELECTED_BUILDING,
  payload: building,
});

export const setPagesInfo = info => ({
  type: ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO,
  payload: info,
});
